import { BoxGeometry, EdgesGeometry, LineSegments } from 'three';
import { assertDefined } from '../../../../cross-team-shared/misc-utils/strict-record';
import { H3BasicMaterial } from '../../../materials/basic/h3-basic-material';
import { PointCloudContentState } from '../../../state/point-cloud-content-state';
import { RendererLayer, setRendererLayers } from '../../render-utils';
import {
  AbstractMeshHelper,
  ConfigureMeshesConfiguration,
} from '../abstract-mesh-helper';
import { ArrowMesh } from '../arrow-mesh';
import { highlightColor } from '../color-utils';

export class InProgressCuboidHelper extends AbstractMeshHelper {
  private arrow: ArrowMesh;
  private wireframe: LineSegments<EdgesGeometry, H3BasicMaterial>;
  private boxGeometry = new BoxGeometry();

  constructor() {
    super();

    this.wireframe = new LineSegments(new EdgesGeometry(this.boxGeometry));
    this.wireframe.userData = {
      meshType: 'InProgressCuboidWireframe',
    };
    this.arrow = new ArrowMesh({
      radius: 0.04,
      headWidth: 0.3,
      headLength: 0.7,
    });
    this.arrow.name = 'InProgressArrow';
  }

  dispose() {
    this.wireframe.geometry.dispose();
    this.boxGeometry.dispose();
    this.arrow.dispose();
  }

  getMeshes() {
    return [this.wireframe, this.arrow];
  }

  protected override updateRendererLayers(_state: PointCloudContentState) {
    const layers = [
      RendererLayer.Main,
      RendererLayer.Projection,
      RendererLayer.Orthographic,
    ];

    setRendererLayers(layers, [this.wireframe, this.arrow]);
  }

  protected override configureMeshes({
    state,
    materialService,
  }: ConfigureMeshesConfiguration) {
    const cuboidState = state.render.inProgressCuboid;
    assertDefined(cuboidState);
    const location = cuboidState.key_locations[0];

    this.wireframe.position.fromArray(location.position);
    this.wireframe.scale.fromArray(location.scale);
    this.wireframe.rotation.fromArray(location.rotation);

    const arrowCuboidState = state.render.inProgressArrowCuboid;
    assertDefined(arrowCuboidState);
    const { reference, target } = arrowCuboidState;

    this.arrow.placeAt(reference, target);

    const highlightMaterial = materialService.get(H3BasicMaterial, {
      color: highlightColor,
    });

    this.wireframe.material = highlightMaterial;
    this.arrow.setMaterial(highlightMaterial);
  }
}
